import React from "react";

const About = () => {
  return (
    <div className="container  px-4">
      <div className="max-w-3xl mx-auto mt-8">
        <h3 className="mb-4 text-3xl md:text-4xl leading-tight  text-coolGray-900 font-bold tracking-tighter">
          About Application
        </h3>
        <p className="text-lg md:text-xl text-coolGray-500 font-medium">
          This is about Easily track your income and expenses with this powerful
          and user-friendly application.
        </p>
      </div>
    </div>
  );
};

export default About;
